import {
  WhatsappTemplateButtonTypeEnum,
  WhatsappTemplateCategoryEnum,
} from "../enums";
import { handleMessageChange } from "./handleMessageChange";

export async function handleTemplateSelectionChange({
  value,
  nodes,
  setNodes,
  templates,
  templatesByName,
  api,
  oldSelectedNode,
  newTemplate,
  urlButton,
  urlButton2,
}) {
  const defaultBody = "";
  const defaultHeaderParameters = {};
  const defaultButtons = [];
  const defaultUrlButton = null;
  const defaultUrlButton2 = null;

  handleMessageChange(
    "buttons",
    defaultButtons,
    nodes,
    setNodes,
    oldSelectedNode,
  );
  handleMessageChange("flowButton", null, nodes, setNodes, oldSelectedNode);
  handleMessageChange(
    "urlButton",
    defaultUrlButton,
    nodes,
    setNodes,
    oldSelectedNode,
  );
  handleMessageChange(
    "urlButton2",
    defaultUrlButton2,
    nodes,
    setNodes,
    oldSelectedNode,
  );
  handleMessageChange("copyCodeButton", null, nodes, setNodes, oldSelectedNode);
  handleMessageChange(
    "limitedTimeOffer",
    undefined,
    nodes,
    setNodes,
    oldSelectedNode,
  );

  // Mettre à jour le message avec les valeurs réinitialisées
  handleMessageChange("body", defaultBody, nodes, setNodes, oldSelectedNode);
  handleMessageChange(
    "whatsappTemplateName",
    value,
    nodes,
    setNodes,
    oldSelectedNode,
  );
  handleMessageChange("headerParameters", {}, nodes, setNodes, oldSelectedNode);
  handleMessageChange("bodyParameters", null, nodes, setNodes, oldSelectedNode);
  handleMessageChange("urlClicks", null, nodes, setNodes, oldSelectedNode);
  handleMessageChange("urlClicks2", null, nodes, setNodes, oldSelectedNode);
  handleMessageChange("urlClickRate", 0, nodes, setNodes, oldSelectedNode);
  handleMessageChange("urlClickRate2", 0, nodes, setNodes, oldSelectedNode);

  if (!oldSelectedNode) {
    handleMessageChange(
      "headerParameters",
      defaultHeaderParameters,
      nodes,
      setNodes,
    );
  }

  let selectedTemplate;
  if (templates) {
    selectedTemplate = templates.find((t) => t.name === value);
  } else {
    selectedTemplate = newTemplate;
  }

  const _limitedTimeOffer = selectedTemplate?.components?.find(
    (c) => c.type === "LIMITED_TIME_OFFER",
  )?.limited_time_offer
    ? {
        expirationDate: undefined,
        expirationDelayInMinutes: undefined,
        expirationType: "delay",
        text: selectedTemplate?.components?.find(
          (c) => c.type === "LIMITED_TIME_OFFER",
        )?.limited_time_offer.text,
      }
    : null;
  const body =
    selectedTemplate?.components?.find((c) => c.type === "BODY")?.text ?? "";
  const footer =
    selectedTemplate?.components?.find((c) => c.type === "FOOTER")?.text ?? "";
  const carousel =
    selectedTemplate?.components?.find((c) => c.type === "CAROUSEL") ?? null;
  const cards = carousel?.cards || null;

  if (cards) {
    let officialWhatsappTemplate =
      await api.officialWhatsappTemplate.maybeFindFirst({
        filter: {
          name: { equals: value },
        },
        select: {
          id: true,
          urlButtonsInCards: true,
        },
      });
    let officialButtons;
    if (
      officialWhatsappTemplate &&
      officialWhatsappTemplate.urlButtonsInCards
    ) {
      officialButtons = officialWhatsappTemplate.urlButtonsInCards;
    }

    const updatedCards = cards.map((card, index) => {
      const headerComponent = card.components.find((c) => c.type === "HEADER");
      const bodyComponent = card.components.find((c) => c.type === "BODY");
      const buttonsComponent = card.components.find(
        (c) => c.type === "BUTTONS",
      );

      const matchingUrlButtons = officialButtons?.find(
        (item) => item.cardIndex === index,
      );
      let btnIndex = 0;
      const updatedButtons =
        buttonsComponent?.buttons.map((button) => {
          if (
            (button.type === "URL" || button.type === "url") &&
            button.url.includes("redirect")
          ) {
            const newUrl =
              matchingUrlButtons?.buttons?.[btnIndex]?.url || button.url;
            btnIndex++; // On incrémente seulement après avoir récupéré l’URL

            return {
              ...button,
              url: newUrl,
            };
          }
          return button;
        }) || [];
      const bodyText = bodyComponent?.text || "";
      const paramMatches = bodyText.match(/{{\d+}}/g);
      const bodyParameters = paramMatches
        ? paramMatches.map(() => ({
            type: "text",
            selected: `contact.whatsappName`,
          }))
        : [];

      return {
        components: [
          {
            type: "HEADER",
            format: headerComponent?.format === "IMAGE" ? "IMAGE" : "VIDEO",
            link:
              headerComponent?.parameters?.[0]?.image?.link ||
              headerComponent?.parameters?.[0]?.video?.link ||
              "",
          },
          {
            type: "BODY",
            text: bodyComponent?.text || "",
            bodyParameters: bodyParameters.length > 0 ? bodyParameters : null,
          },
          {
            type: "BUTTONS",
            buttons: updatedButtons || [],
          },
        ],
      };
    });

    handleMessageChange(
      "cards",
      updatedCards,
      nodes,
      setNodes,
      oldSelectedNode,
    );
  } else {
    handleMessageChange("cards", cards, nodes, setNodes, oldSelectedNode);
  }
  let category;
  if (_limitedTimeOffer) {
    category = WhatsappTemplateCategoryEnum.LIMITED_TIME_OFFER;
  } else if (cards) {
    category = WhatsappTemplateCategoryEnum.CAROUSEL;
  } else {
    category = selectedTemplate?.category;
  }

  handleMessageChange("category", category, nodes, setNodes, oldSelectedNode);
  handleMessageChange(
    "limitedTimeOffer",
    _limitedTimeOffer,
    nodes,
    setNodes,
    oldSelectedNode,
  );
  handleMessageChange("body", body, nodes, setNodes, oldSelectedNode);
  handleMessageChange("footer", footer, nodes, setNodes, oldSelectedNode);

  // Mettre à jour les paramètres de l'en-tête
  const headerImage = selectedTemplate?.components?.find(
    (c) => c.format === "IMAGE" && c.type === "HEADER",
  );
  const headerVideo = selectedTemplate?.components?.find(
    (c) => c.format === "VIDEO" && c.type === "HEADER",
  );
  const bodyComponent = selectedTemplate?.components?.find(
    (c) => c.type === "BODY",
  );

  if (headerImage && !oldSelectedNode) {
    let link = selectedTemplate?.components[0]?.example?.header_handle[0] ?? "";
    if (
      link ===
      "https://scontent.whatsapp.net/v/t61.29466-34/374730438_619291030350833_3365796789354478627_n.jpg?ccb=1-7&_nc_sid=8b1bef&_nc_ohc=Mm-lFP-n6HQQ7kNvgHcop0-&_nc_ht=scontent.whatsapp.net&edm=AH51TzQEAAAA&_nc_gid=Ai9pJ5h-3MJtuQM9kod7mBf&oh=01_Q5AaIK5wjbv23H36O10tfiAU7rYboYXGSVs3XE3pcUFtrAq0&oe=670AD7D6"
    ) {
      link = "";
    }

    handleMessageChange(
      "headerParameters",
      { type: "image", image: { link: link } },
      nodes,
      setNodes,
      oldSelectedNode,
    );
  } else if (headerVideo && !oldSelectedNode) {
    let link = selectedTemplate?.components[0]?.example?.header_handle[0] ?? "";
    if (
      link ===
      "https://firebasestorage.googleapis.com/v0/b/phocea-75b47.appspot.com/o/Compa%2FVideo%20Noe%CC%88l%20format%20carre%CC%81.mp4?alt=media&token=c9c0e395-5ea6-49f8-bb30-3d20d85cd943"
    ) {
      link = "";
    }
    handleMessageChange(
      "headerParameters",
      { type: "video", video: { link: link } },
      nodes,
      setNodes,
      oldSelectedNode,
    );
  }
  if (bodyComponent?.example) {
    var bodyParams = [];
    bodyComponent.example?.body_text[0].map(() => {
      bodyParams.push({
        type: "text",
        selected: "contact.whatsappName",
      });
    });
    handleMessageChange(
      "bodyParameters",
      bodyParams,
      nodes,
      setNodes,
      oldSelectedNode,
    );
  }

  const buttons = selectedTemplate?.components?.find(
    (c) => c.type === "BUTTONS",
  )?.buttons;

  let replyButtons = [];
  let hasUrlButton = false;

  const isUrlButtonAtBottom = buttons?.length > 0 && buttons[0]?.type !== "URL";

  handleMessageChange(
    "isUrlButtonAtBottom",
    isUrlButtonAtBottom,
    nodes,
    setNodes,
    oldSelectedNode,
  );

  console.log(
    `Boutons dans le template ${value} buttons=${JSON.stringify(buttons)}`,
  );

  buttons?.map(async (button) => {
    const { type, text, example } = button;
    console.log(`Bouton type=${type} text=${text}, example=${example}`);

    switch (type) {
      case WhatsappTemplateButtonTypeEnum.URL:
        {
          let officialWhatsappTemplate =
            await api.officialWhatsappTemplate.maybeFindFirst({
              filter: {
                name: { equals: value },
              },
              select: {
                id: true,
                buttonUrlLink: true,
                buttonUrlLink2: true,
              },
            });

          if (officialWhatsappTemplate) {
            const buttonConfig = {
              first: {
                key: "urlButton",
                url: officialWhatsappTemplate.buttonUrlLink || button.url,
                button: urlButton,
              },
              second: {
                key: "urlButton2",
                url: officialWhatsappTemplate.buttonUrlLink2 || button.url,
                button: urlButton2,
              },
            };

            const currentConfig = hasUrlButton
              ? buttonConfig.second
              : buttonConfig.first;

            handleMessageChange(
              currentConfig.key,
              {
                text: text,
                url: currentConfig.url,
                trackingEnabled: true, // Default to enabled for official templates
                ...(currentConfig.button && {
                  gadgetId: currentConfig.button.gadgetId,
                  redirectionUrlId: currentConfig.button.redirectionUrlId,
                }),
              },
              nodes,
              setNodes,
              oldSelectedNode,
            );

            if (!hasUrlButton) {
              hasUrlButton = true;
            }
          }
        }
        break;

      case WhatsappTemplateButtonTypeEnum.COPY_CODE:
        handleMessageChange(
          "copyCodeButton",
          { text: example[0] },
          nodes,
          setNodes,
          oldSelectedNode,
        );
        break;

      case WhatsappTemplateButtonTypeEnum.FLOW:
        {
          const officialWhatsappTemplate = templatesByName[value];
          if (!officialWhatsappTemplate) {
            console.error("No official whatsapp template found");
            return;
          }
          console.log(
            `Official whatsapp template found with name ${value}: ${JSON.stringify(officialWhatsappTemplate)}`,
          );
          const flowButton = (officialWhatsappTemplate.components || [])
            .find(({ type }) => type === "BUTTONS")
            ?.buttons?.find(({ type }) => type === "FLOW");
          
          if (flowButton) {
            const { text, flow_id, flow_action, navigate_screen } = flowButton;
            console.log(
              `Flow button found text=${text} flow_id=${flow_id} flow_action=${flow_action} navigate_screen=${navigate_screen}`,
            );

            handleMessageChange(
              "flowButton",
              {
                flowId: flow_id,
                flowAction: flow_action,
                navigateScreen: navigate_screen,
                text,
              },
              nodes,
              setNodes,
              oldSelectedNode,
            );
          }
        }
        break;

      default:
        replyButtons.push({
          title: text,
        });
        break;
    }
  });

  handleMessageChange(
    "buttons",
    replyButtons,
    nodes,
    setNodes,
    oldSelectedNode,
  );

  handleMessageChange(
    "status",
    selectedTemplate?.status?.toLowerCase(),
    nodes,
    setNodes,
    oldSelectedNode,
  );
  handleMessageChange("hasFailed", false, nodes, setNodes, oldSelectedNode);
}
